// LICENSE : MIT
"use strict";
import Document from "./Document";
export default class EmptyDocument extends Document {
    constructor({pdfURL}) {
        super({
            pdfURL,
            pages: []
        });
    }
}



// WEBPACK FOOTER //
// ./src/js/domain/document/EmptyDocument.js